import { useIntl } from 'react-intl';

import { Dropdown } from 'components/Forms';

interface ICareProgramFilterProps {
  handleChange: any;
  options: ISelectOption[];
  value: ISelectOption[];
}

const CarePrograms = ({ handleChange, options, value }: ICareProgramFilterProps) => {
  const intl = useIntl();
  return (
    <Dropdown
      dataTestId="filter-carePrograms"
      variant="form"
      options={options}
      placeholder={intl.formatMessage({ id: 'selectProgramKey' })}
      onChange={handleChange}
      isMulti
      value={value}
      isClearable={false}
      minWidth={200}
      label={intl.formatMessage({ id: 'programsKey' })}
    />
  );
};

export default CarePrograms;
